import { Textarea, TextInput } from '@any-ui-react/core';
import { useFormContext } from 'react-hook-form';

import { EmployeeMaritalStatusRadioGroup } from '@/common/components/shared/employee-marital-status-radio-group/EmployeeMaritalStatusRadioGroup';
import { useEmployeeDetailContext } from '@/common/contexts/EmployeeDetailContext';
import { useEmployeeAccess } from '@/common/hooks/employees/useEmployeeAccess';
import type { EmployeePersonalInformationFormDataType } from '@/common/types';

export const SocialInsuranceFormFields = () => {
  const { register } = useFormContext<EmployeePersonalInformationFormDataType>();

  const { employeeDetail } = useEmployeeDetailContext();
  const isNewRecord = !employeeDetail.id;
  const { hasEmployeePersonalInformationEditAccess } = useEmployeeAccess();
  const isEditable = hasEmployeePersonalInformationEditAccess || isNewRecord;

  return (
    <div className="mb-6">
      <div className="mb-4 font-semibold">Social Insurance</div>
      <fieldset className="form-fieldset">
        <TextInput
          {...register('taxCode')}
          className="col-span-2 sm:col-span-1"
          disabled={!isEditable}
          label="Social Insurance Type"
          placeholder="Enter Tax Code"
        />
        <TextInput
          {...register('socialInsuranceNumber')}
          className="col-span-2 sm:col-span-1"
          disabled={!isEditable}
          label="Social Insurance Number"
          placeholder="Enter Social Insurance Number"
        />
        <TextInput
          {...register('pensionVoluntaryContributionRate')}
          className="col-span-2 sm:col-span-1"
          disabled={!isEditable}
          label="Pension voluntary contribution rate"
          placeholder="Enter pension voluntary contribution rate"
        />
        <TextInput
          {...register('taxWithholdingRate')}
          className="col-span-2 sm:col-span-1"
          disabled={!isEditable}
          label="Tax withholding rate"
          placeholder="Enter Tax withholding rate"
        />

        <Textarea
          {...register('socialInsuranceNotes')}
          autosize={true}
          className="col-span-2 col-start-1"
          disabled={!isEditable}
          label="Notes"
          minRows={5}
          placeholder="Enter Notes"
        />

        <EmployeeMaritalStatusRadioGroup />
      </fieldset>
    </div>
  );
};
